
import React, {Component} from 'react'
import PropTypes from 'prop-types'

const CLASS_NAME = 'octicon octicon-grabber'
class GrabberIcon extends Component {
  render() {
    let defaults = {
      height: 16,
      width: 8,
      viewBox: '0 0 8 16',
      'aria-hidden': true
    }

    let {className, size} = this.props
    if (className) {
      className = CLASS_NAME + ' ' + className
    } else {
      className = CLASS_NAME
    }

    if (size === 'mega') {
      defaults.height *= 2
      defaults.width *= 2
    }

    return (
      <svg {...defaults} {...this.props} className={className}>
        <path fillRule="evenodd" d="M8 4v1H0V4h8zM0 8h8V7H0v1zm0 3h8v-1H0v1z"/>
      </svg>
    )
  }
}
GrabberIcon.propTypes = {
  className: PropTypes.string
}
export default GrabberIcon
